export default __webpack_public_path__ + "static/media/image8.38eeb0a3.jpeg";